import script from "./AgentGeneralSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentGeneralSettings.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import NeueLoading from "@/components/neue/NeueLoading.vue";
import SaveBar from "@/components/SaveBar.vue";
import SecondaryNav from "@/components/SecondaryNav.vue";
import SecondaryTop from "@/components/SecondaryTop.vue";
script.components = Object.assign({}, { NeueLoading, SaveBar, SecondaryNav, SecondaryTop }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { NeueLoading, SaveBar, SecondaryNav, SecondaryTop }, script.__o.components);}